// extracted by mini-css-extract-plugin
export default {"course":"CourseList-modules__course__qfCfp","courseEmpty":"CourseList-modules__courseEmpty__ZPmID","show-keyframe":"CourseList-modules__show-keyframe__G_15O"};